import { Linking } from 'react-native';
import { isWeb } from './platform';
import { getSecureValue } from './secureStorage';
import { Alert } from './modals';

export const IDENTITY_SERVER_DATA = {
  client_id: '84216b17-e6a1-4ba5-a7ac-6f513b3f7f24',
  client_secret: '',
};

export const ENVIRONMENTS = {
  DEV: 'dev',
  QA: 'qa',
  STG: 'stg',
  PROD: 'prod',
};

export const ENVIRONMENTS_NAME = {
  dev: 'Development',
  qa: 'QA',
  stg: 'Staging',
  prod: 'Production',
};

export const FEATURE_FLAGS = {
  dev: {
    general: { 'device-alive-event': true, showapiresponsetime: true, 'signalr-debugger': true, 'welcome-tour': false },
    machine: { chart: true, month: true, panel: true, 'phone-show-period-selector': true, scheduled: true, week: true, year: true },
    settings: {
      administration: true,
      connector: true,
      devices: true,
      machines: true,
      users: true,
      'test-language': true,
      'pseudolocale-language': true,
    },
  },
  qa: {
    general: { 'device-alive-event': false, showapiresponsetime: true, 'signalr-debugger': false, 'welcome-tour': false },
    machine: { chart: true, month: true, panel: true, 'phone-show-period-selector': true, scheduled: true, week: true, year: true },
    settings: {
      administration: true,
      connector: true,
      devices: true,
      machines: true,
      users: true,
      'test-language': true,
      'pseudolocale-language': true,
    },
  },
  stg: {
    general: { 'device-alive-event': false, showapiresponsetime: false, 'signalr-debugger': false, 'welcome-tour': false },
    machine: { chart: false, month: false, panel: false, 'phone-show-period-selector': false, scheduled: false, week: false, year: false },
    settings: {
      administration: false,
      connector: false,
      devices: true,
      machines: true,
      users: true,
      'test-language': false,
      'pseudolocale-language': false,
    },
  },
  prod: {
    general: { 'device-alive-event': false, showapiresponsetime: false, 'signalr-debugger': false, 'welcome-tour': false },
    machine: { chart: false, month: false, panel: false, 'phone-show-period-selector': false, scheduled: false, week: false, year: false },
    settings: {
      administration: false,
      connector: false,
      devices: true,
      machines: true,
      users: true,
      'test-language': false,
      'pseudolocale-language': false,
    },
  },
};

export const VERSION = '1.4.600';

export const getWebUrl = (env: string) => {
  const urls = {
    [ENVIRONMENTS.DEV]: 'https://dev.smarfac.com',
    [ENVIRONMENTS.QA]: 'https://qa.smarfac.com',
    [ENVIRONMENTS.STG]: 'https://stg.smarfac.com',
    [ENVIRONMENTS.PROD]: 'https://smarfac.com',
  };

  return urls[env] || 'https://smarfac.com';
};

export const downloadConnector = async () => {
  const env = getSecureValue('env');

  if (isWeb) {
    const urls = {
      [ENVIRONMENTS.DEV]: 'https://download-dev.smarfac.com/ConnectorSetup.exe',
      [ENVIRONMENTS.QA]: 'https://download-qa.smarfac.com/ConnectorSetup.exe',
      [ENVIRONMENTS.STG]: 'https://download-stg.smarfac.com/ConnectorSetup.exe',
      [ENVIRONMENTS.PROD]: 'https://download.smarfac.com/ConnectorSetup.exe',
    };
    window.open(urls[env] || 'https://download.smarfac.com/ConnectorSetup.exe');
  } else {
    const url = 'https://smarfac.com/download-the-connector/';
    Linking.canOpenURL(url).then((supported) => {
      if (supported) {
        Linking.openURL(url);
      } else {
        Alert({
          title: url,
          actions: [
            {
              text: 'Ok',
              onPress: () => console.log('Ok Pressed'),
              style: 'primary',
            },
          ],
        });
      }
    });
  }
};
